import script from "./PurchasePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasePage.vue?vue&type=script&setup=true&lang=js"

import "./PurchasePage.vue?vue&type=style&index=0&id=756aeffe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756aeffe"]])

export default __exports__